import Dates from '../util/Dates';
import moment from 'moment';

const BASE_MONDAY = Dates.getMonday(new Date());
const YESTERDAY = Dates.getYesterday();
const TOMORROW = Dates.getTomorrow();


console.log('Generate Test Data',
    moment().add(1, 'seconds').format('YYYY-MM-DD HH:mm:ss')
    //"start": "2020-10-08 00:00:00",
    
);

const dataSchema = {
    "rsvp_info": {
      "rsvp_description": "RSVP Description",
      "rsvp_yes_title": "RSVP Yes Title",
      "rsvp_yes_subtitle": "RSVP Yes Subtitle",
      "rsvp_no_title": "RSVP No Title",
      "rsvp_no_subtitle": "RSVP No Subtitle",
      "rsvp_image": {
        "ID": 73,
        "id": 73,
        "title": "water_in_a_cup",
        "filename": "water_in_a_cup.png",
        "filesize": 987710,
        "url": "http://localhost.cfarpm/app/uploads/2020/09/water_in_a_cup.png",
        "link": "http://localhost.cfarpm/?attachment_id=73",
        "alt": "",
        "author": "1",
        "description": "",
        "caption": "",
        "name": "water_in_a_cup",
        "status": "inherit",
        "uploaded_to": 23,
        "date": "2020-10-12 23:58:06",
        "modified": "2020-10-12 23:58:06",
        "menu_order": 0,
        "mime_type": "image/png",
        "type": "image",
        "subtype": "png",
        "icon": "http://localhost.cfarpm/wp/wp-includes/images/media/default.png",
        "width": 1920,
        "height": 1080,
        "sizes": {
          "thumbnail": "http://localhost.cfarpm/app/uploads/2020/09/water_in_a_cup-150x150.png",
          "thumbnail-width": 150,
          "thumbnail-height": 150,
          "medium": "http://localhost.cfarpm/app/uploads/2020/09/water_in_a_cup-300x169.png",
          "medium-width": 300,
          "medium-height": 169,
          "medium_large": "http://localhost.cfarpm/app/uploads/2020/09/water_in_a_cup-768x432.png",
          "medium_large-width": 768,
          "medium_large-height": 432,
          "large": "http://localhost.cfarpm/app/uploads/2020/09/water_in_a_cup-1024x576.png",
          "large-width": 1024,
          "large-height": 576,
          "1536x1536": "http://localhost.cfarpm/app/uploads/2020/09/water_in_a_cup-1536x864.png",
          "1536x1536-width": 1536,
          "1536x1536-height": 864,
          "2048x2048": "http://localhost.cfarpm/app/uploads/2020/09/water_in_a_cup.png",
          "2048x2048-width": 1920,
          "2048x2048-height": 1080
        }
      }
    },
    "attendee": {
      "id": "1_wp_c81e728d9d4c2f636f067f89cc14862c",
      "wp_id": "2",
      "first_name": "Attendee",
      "last_name": "Profile",
      "title": "",
      "avatar": "http://2.gravatar.com/avatar/b23c850f7684b8a293db9db009d630da?s=52&d=mm&r=g",
      "chat_token": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiMV93cF9jODFlNzI4ZDlkNGMyZjYzNmYwNjdmODljYzE0ODYyYyJ9.Ly-YFdKzxMU-GQ5qUOrjeYmqz-ixRwLXHNDkOZwph9A",
      "location": "Staff"
    },
    "rooms": [
      {
        "title": "Test Main Room",
        "description": "This is a test room",
        "stream": "f541d515-bd11-4ef6-b559-dc37c27b2094",
        "chat": "hijk",
        "region": [
          "all"
        ],
        "auto_register": true,
        "start": moment().add(10, 'seconds').format('YYYY-MM-DD HH:mm:ss'),
        "end": moment().add(20, 'seconds').format('YYYY-MM-DD HH:mm:ss'),
        "unique": "5f772ec6da060",
        "registered": true
      },
      {
        "title": "Test Breakout Room",
        "description": "This is a test beakout room",
        "stream": "5deeded8-95e7-4acc-bfa5-10f100352545",
        "chat": "abcd",
        "region": [
          "all"
        ],
        "auto_register": false,
        "start": moment().add(20, 'seconds').format('YYYY-MM-DD HH:mm:ss'),
        "end": moment().add(30, 'seconds').format('YYYY-MM-DD HH:mm:ss'),
        "unique": "5f772ec6de32a",
        "registered": true
      },
      {
        "title": "Test Breakout Room 2",
        "description": "This is a test beakout room",
        "stream": "5deeded8-95e7-4acc-bfa5-10f100352542",
        "chat": "efgh",
        "region": [
          "all"
        ],
        "auto_register": false,
        "start": moment().add(20, 'seconds').format('YYYY-MM-DD HH:mm:ss'),
        "end": moment().add(30, 'seconds').format('YYYY-MM-DD HH:mm:ss'),
        "unique": "5f772ec12332a",
        "registered": false
      },
      {
        "title": "Test Breakout Room 3",
        "description": "This is a test beakout room",
        "stream": "5deeded8-95e7-4acc-bfa5-10f100352543",
        "chat": "lmnop",
        "region": [
          "all"
        ],
        "auto_register": false,
        "start": moment().add(20, 'seconds').format('YYYY-MM-DD HH:mm:ss'),
        "end": moment().add(30, 'seconds').format('YYYY-MM-DD HH:mm:ss'),
        "unique": "5f772ec12332b",
        "registered": false
      },
      {
        "title": "Another Breakout Room",
        "description": "This is a test beakout room",
        "stream": "5deeded8-95e7-4acc-bfa5-10f100352544",
        "chat": "qrst",
        "region": [
          "all"
        ],
        "auto_register": false,
        "start": moment().add(31, 'seconds').format('YYYY-MM-DD HH:mm:ss'),
        "end": moment().add(40, 'seconds').format('YYYY-MM-DD HH:mm:ss'),
        "unique": "5f7873a930e51",
        "registered": true,
        "autoplay": true
      },
      
      {
        "title": "Test Breakout Room Tomorrow",
        "description": "This is a test beakout room for tomorrow",
        "stream": "5deeded8-95e7-4acc-bfa5-10f100352545",
        "chat": "yzab",
        "region": [
          "all"
        ],
        "auto_register": false,
        "start": moment().add(1, 'days').format('YYYY-MM-DD HH:mm:ss'),
        "end": moment().add(2, 'days').format('YYYY-MM-DD HH:mm:ss'),
        "unique": "5f78123930e51",
        "registered": true,
        "autoplay": true
      }
    ],
    "event": {
      "main_event_name": "",
      "main_event_description": "",
      "start": "2020-10-02 22:00:00",
      "end": "",
      "event_assets": {
        "primary_logo": {
          "ID": 51,
          "id": 51,
          "title": "logo_cfa",
          "filename": "logo_cfa.png",
          "filesize": 1890,
          "url": "http://localhost.cfarpm/app/uploads/2020/09/logo_cfa.png",
          "link": "http://localhost.cfarpm/?attachment_id=51",
          "alt": "",
          "author": "1",
          "description": "",
          "caption": "",
          "name": "logo_cfa",
          "status": "inherit",
          "uploaded_to": 23,
          "date": "2020-10-05 14:53:09",
          "modified": "2020-10-05 14:53:09",
          "menu_order": 0,
          "mime_type": "image/png",
          "type": "image",
          "subtype": "png",
          "icon": "http://localhost.cfarpm/wp/wp-includes/images/media/default.png",
          "width": 50,
          "height": 48,
          "sizes": {
            "thumbnail": "http://localhost.cfarpm/app/uploads/2020/09/logo_cfa.png",
            "thumbnail-width": 50,
            "thumbnail-height": 48,
            "medium": "http://localhost.cfarpm/app/uploads/2020/09/logo_cfa.png",
            "medium-width": 50,
            "medium-height": 48,
            "medium_large": "http://localhost.cfarpm/app/uploads/2020/09/logo_cfa.png",
            "medium_large-width": 50,
            "medium_large-height": 48,
            "large": "http://localhost.cfarpm/app/uploads/2020/09/logo_cfa.png",
            "large-width": 50,
            "large-height": 48,
            "1536x1536": "http://localhost.cfarpm/app/uploads/2020/09/logo_cfa.png",
            "1536x1536-width": 50,
            "1536x1536-height": 48,
            "2048x2048": "http://localhost.cfarpm/app/uploads/2020/09/logo_cfa.png",
            "2048x2048-width": 50,
            "2048x2048-height": 48
          }
        },
        "secondary_logo": {
          "ID": 52,
          "id": 52,
          "title": "logo_rpm",
          "filename": "logo_rpm.png",
          "filesize": 4096,
          "url": "http://localhost.cfarpm/app/uploads/2020/09/logo_rpm.png",
          "link": "http://localhost.cfarpm/?attachment_id=52",
          "alt": "",
          "author": "1",
          "description": "",
          "caption": "",
          "name": "logo_rpm",
          "status": "inherit",
          "uploaded_to": 23,
          "date": "2020-10-05 14:53:19",
          "modified": "2020-10-05 14:53:19",
          "menu_order": 0,
          "mime_type": "image/png",
          "type": "image",
          "subtype": "png",
          "icon": "http://localhost.cfarpm/wp/wp-includes/images/media/default.png",
          "width": 142,
          "height": 37,
          "sizes": {
            "thumbnail": "http://localhost.cfarpm/app/uploads/2020/09/logo_rpm.png",
            "thumbnail-width": 142,
            "thumbnail-height": 37,
            "medium": "http://localhost.cfarpm/app/uploads/2020/09/logo_rpm.png",
            "medium-width": 142,
            "medium-height": 37,
            "medium_large": "http://localhost.cfarpm/app/uploads/2020/09/logo_rpm.png",
            "medium_large-width": 142,
            "medium_large-height": 37,
            "large": "http://localhost.cfarpm/app/uploads/2020/09/logo_rpm.png",
            "large-width": 142,
            "large-height": 37,
            "1536x1536": "http://localhost.cfarpm/app/uploads/2020/09/logo_rpm.png",
            "1536x1536-width": 142,
            "1536x1536-height": 37,
            "2048x2048": "http://localhost.cfarpm/app/uploads/2020/09/logo_rpm.png",
            "2048x2048-width": 142,
            "2048x2048-height": 37
          }
        }
      },
      "support_email": "",
      "support_subject": ""
    },
    "express_support_waitlist": "",
    "express_support_faq": "",
    "wordpress": {
      "logout": "http://localhost.cfarpm/wp/wp-login.php?action=logout&amp;_wpnonce=26e9c5098b"
    },
    "isRegistered": "true",
    "isRSVP": "1",
    "current_event": "23",
    "theme": {
      "link": "http://localhost.cfarpm/app/themes/launchframe"
    }
  };

// const dataSchema = {
//     event: {
//         event_id: 'EVENT_ID', //(post id)
//         hasRSVP: false
//     },
//     express_support: 'http://google.com', //url link for the nav
//     attendee: {
//         id: 'ATTENDEE_ID',
//         first_name: 'FIRST_NAME',
//         last_name: 'LAST_NAME',
//         title: 'TITLE',
//         location: 'LOCATION', // (i.e. 'Atlanta, GA')
//         avatar: 'http://placehold.it/52x52', //profile thumbnail (shown in chat and nav)
//         chat_token: 'SOME_USER_TOKEN', //GetStreams Token generated from attendee id
//     },
//     rooms: [
//         {
//             chat: "CHAT_ID",
//             stream: "STREAM_ID",
//             title: "ROOM_TITLE", 
//             auto_register: true, 
//             registered: true,
//             description: "ROOM_DESCRIPTION",
//             region: ["all"],
//             registration_service: false,
//             registration_service_id: "",
//             start: "03/10/2020 12:00 am",
//             end: "03/10/2020 12:30 am",
//             unique: "5f772ec6da060", //room id
//             reserved: false //has this user reserved this room
//         }
//     ],

//     theme: { //provided in launchframe
//         link: '' //the url path to the theme
//     } 
// };




export default dataSchema;